module.exports = __webpack_public_path__ + "img/trash_hover.9942988c.svg";